// extracted by mini-css-extract-plugin
module.exports = {"PageHolder":"Dashboard_PageHolder__3rWPW","tabHolder":"Dashboard_tabHolder__HGZRS","onFocus":"Dashboard_onFocus___dEis"};